import { render } from "./WCSelect.vue?vue&type=template&id=fb1458fa&scoped=true"
import script from "./WCSelect.vue?vue&type=script&lang=js"
export * from "./WCSelect.vue?vue&type=script&lang=js"

import "./WCSelect.vue?vue&type=style&index=0&id=fb1458fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1458fa"]])

export default __exports__